import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75a0ff92"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_2 = { id: "form-training-put" }
const _hoisted_3 = { class: "card background_1 p-4 d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "row g-4 p-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "*", -1))
const _hoisted_7 = { class: "col-sm-12 col-xl-7" }
const _hoisted_8 = {
  for: "form-training-put-title",
  class: "form-label cor_texto_1"
}
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { class: "col-sm-4 col-md-5 col-lg-4 col-xl-2" }
const _hoisted_11 = {
  for: "form-training-put-score",
  class: "form-label cor_texto_1"
}
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = { class: "col-sm-8 col-md-7 col-lg-8 col-xl-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-training-put-active",
  class: "form-label cor_texto_1"
}, "Situação: ", -1))
const _hoisted_15 = {
  for: "form-training-put-active",
  style: {"cursor":"pointer"},
  class: "d-flex justify-content-between align-items-center el-input__inner"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  id: "form-training-put-fields-description-date",
  class: "gap-4"
}
const _hoisted_19 = {
  for: "form-training-put-description",
  class: "form-label cor_texto_1"
}
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = {
  for: "form-training-put-date",
  class: "form-label cor_texto_1"
}
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = {
  id: "form-training-put-date",
  class: "row g-4"
}
const _hoisted_25 = { class: "col-sm-6 col-lg-12" }
const _hoisted_26 = { class: "col-sm-6 col-lg-12" }
const _hoisted_27 = {
  key: 1,
  class: "col-sm-6 d-flex flex-column justify-content-between"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-training-put-groups-1",
  class: "form-label cor_texto_1"
}, "Liberada para: ", -1))
const _hoisted_29 = { class: "col-sm-6 align-self-end" }
const _hoisted_30 = {
  for: "form-training-put-groups-2",
  class: "d-none d-sm-block form-label cor_texto_1"
}
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = {
  id: "box-table-questions",
  class: "background_1 card my-7"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-undo-alt me-4",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0"}
}, null, -1))
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0"}
}, null, -1))
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-pencil-alt",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0"}
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_41 = {
  id: "box-table-questions",
  class: "background_1 card my-7"
}
const _hoisted_42 = { class: "certificate-header mb-4" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Configuração do Certificado", -1))
const _hoisted_44 = { class: "d-flex align-items-center gap-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cor_texto_1" }, "Emitir certificado", -1))
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "row g-4" }
const _hoisted_48 = { class: "col-sm-12 col-xl-7" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-training-put-certificate-responsible",
  class: "form-label cor_texto_1"
}, "Nome responsável:", -1))
const _hoisted_50 = { class: "col-sm-4 col-md-3 col-lg-2 col-xl-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-training-put-certificate-workload",
  class: "form-label cor_texto_1"
}, "Carga horária (horas):", -1))
const _hoisted_52 = { class: "col-sm-12 col-xl-7" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label cor_texto_1" }, "Logo certificado:", -1))
const _hoisted_54 = {
  key: 0,
  class: "logo-upload-card"
}
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"logo-upload-inner\" data-v-75a0ff92><div class=\"logo-upload-icon\" data-v-75a0ff92><span class=\"logo-upload-line horizontal\" data-v-75a0ff92></span><span class=\"logo-upload-line vertical\" data-v-75a0ff92></span></div><div class=\"logo-upload-info\" data-v-75a0ff92><span class=\"logo-upload-title\" data-v-75a0ff92>Faça o upload do logo</span><span class=\"logo-upload-subtitle\" data-v-75a0ff92>Formatos: JPG ou PNG (máx. 5 MB)</span></div></div>", 1)
const _hoisted_56 = {
  key: 1,
  class: "mt-2 logo-preview"
}
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "col-sm-12 col-md-6 col-xl-5" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-training-put-certificate-position",
  class: "form-label cor_texto_1"
}, "Cargo responsável:", -1))
const _hoisted_60 = { class: "col-sm-12 col-xl-7" }
const _hoisted_61 = {
  key: 0,
  class: "signature-preview-container"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label cor_texto_1" }, "Assinatura Cadastrada:", -1))
const _hoisted_63 = { class: "preview-box" }
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "preview-details" }
const _hoisted_66 = { class: "preview-name" }
const _hoisted_67 = { class: "preview-role" }
const _hoisted_68 = { class: "preview-role" }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-training-put-certificate-signature",
  class: "form-label cor_texto_1"
}, " Nenhuma assinatura cadastrada ", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn background_btn_1",
  style: {"color":"var(--cor_icones_1)"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-save",
    style: {"color":"var(--cor_icones_1)"},
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Salvar ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CampHeader = _resolveComponent("CampHeader")!
  const _component_MediaCardCore = _resolveComponent("MediaCardCore")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_CampTable = _resolveComponent("CampTable")!
  const _component_SignatureModal = _resolveComponent("SignatureModal")!
  const _component_CampFormRackSubmitBtn = _resolveComponent("CampFormRackSubmitBtn")!
  const _component_ModalQuiz = _resolveComponent("ModalQuiz")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitForm && _ctx.onSubmitForm(...args)), ["prevent"]))
      }, [
        _createVNode(_component_CampHeader, null, {
          title: _withCtx(() => [
            _createTextVNode("Editar Treinamento")
          ]),
          button: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `/treinamentos`,
              class: "btn btn_background_1"
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createTextVNode(" Voltar ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("fieldset", _hoisted_3, [
            _createVNode(_component_MediaCardCore, {
              updateMode: true,
              mediaFile: _ctx.mediaFile,
              "onGet:UpdatedMediaFile": _ctx.handleUpdatedMediaFile
            }, null, 8, ["mediaFile", "onGet:UpdatedMediaFile"])
          ]),
          _createElementVNode("fieldset", {
            class: "card background_1",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetWarning && _ctx.resetWarning(...args)))
          }, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.isRequiredField)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(" Campos obrigatórios "),
                    _hoisted_6
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _createTextVNode("Nome interno: "),
                  (_ctx.isRequiredField)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_9, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  placeholder: "Treinamento...",
                  modelValue: _ctx.formModel.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModel.title) = $event)),
                  clearable: "",
                  type: "text",
                  name: "form-training-put-title",
                  id: "form-training-put-title"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _createTextVNode("Prêmio: "),
                  (_ctx.isRequiredField)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_12, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formModel.points,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.points) = $event)),
                  type: "number",
                  name: "form-training-put-score",
                  id: "form-training-put-score",
                  min: 0,
                  max: 99
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("label", _hoisted_15, [
                  (_ctx.activeStatus)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Ativo"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_17, "Inativo")),
                  _createVNode(_component_el_switch, {
                    id: "form-training-put-active",
                    modelValue: _ctx.activeStatus,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeStatus) = $event)),
                    class: "ml-2 ms-2",
                    style: {"--el-switch-on-color":"var(--el-color-primary)"}
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_19, [
                    _createTextVNode("Descrição do treinamento: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_20, "*"))
                      : _createCommentVNode("", true),
                    (_ctx.formModel.description.length)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          style: _normalizeStyle(`color: ${_ctx.infoMaxCharactersWarning ? 'var(--cor_indicadores_4)' : 'var(--cor_texto_2)'}`)
                        }, _toDisplayString(_ctx.infoMaxCharactersWarning ? _ctx.infoMaxCharactersWarning : _ctx.infoMaxCharacters), 5))
                      : _createCommentVNode("", true),
                    _hoisted_21
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formModel.description,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModel.description) = $event)),
                    clearable: "",
                    rows: 3,
                    type: "textarea",
                    placeholder: "Digite...",
                    name: "form-training-put-description",
                    id: "form-training-put-description"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_22, [
                    _createTextVNode("Data início/fim: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_23, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formModel.initial_date,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formModel.initial_date) = $event)),
                        type: "datetime",
                        placeholder: "Selecione data de início",
                        format: "DD/MM/YYYY HH:mm:ss",
                        "default-time": _ctx.moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                        "disabled-date": _ctx.handleDisabledDateMin,
                        clearable: false
                      }, null, 8, ["modelValue", "default-time", "disabled-date"])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formModel.end_date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formModel.end_date) = $event)),
                        type: "datetime",
                        placeholder: "Selecione data de término",
                        format: "DD/MM/YYYY HH:mm:ss",
                        "default-time": _ctx.moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                        "disabled-date": _ctx.handleDisabledDateMax,
                        clearable: false
                      }, null, 8, ["modelValue", "default-time", "disabled-date"])
                    ])
                  ])
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.trainingGroupsId,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trainingGroupsId) = $event)),
                      type: "text",
                      placeholder: "Selecione...",
                      name: "form-training-put-groups-1",
                      id: "form-training-put-groups-1",
                      class: "w-100",
                      disabled: _ctx.trainingGroupsOptions.length < 2
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainingGroupsOptions, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.key,
                            value: option.key,
                            label: option.label
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, [
                  _createTextVNode("Liberada para: "),
                  (_ctx.isRequiredField)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_31, "*"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.trainingGroupsId === _ctx.TRAINING_GROUPS_OPTIONS.COMPANY.KEY)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      multiple: "",
                      disabled: _ctx.isLoading || _ctx.companyOptions.length < 1,
                      modelValue: _ctx.formModel.id_company,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formModel.id_company) = $event)),
                      type: "text",
                      placeholder: "Selecione uma Companhia...",
                      name: "form-training-put-groups-2",
                      id: "form-training-put-groups-2",
                      class: "w-100"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyOptions, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.key,
                            value: option.key,
                            label: option.label
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["disabled", "modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.trainingGroupsId === _ctx.TRAINING_GROUPS_OPTIONS.STORE.KEY)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 1,
                      multiple: "",
                      disabled: _ctx.isLoading || _ctx.storeOptions.length < 1,
                      modelValue: _ctx.formModel.id_store,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formModel.id_store) = $event)),
                      type: "text",
                      placeholder: "Selecione uma ou mais lojas",
                      name: "form-training-put-groups-2",
                      id: "form-training-put-groups-2",
                      class: "w-100"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeOptions, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.key,
                            value: option.key,
                            label: option.label
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["disabled", "modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.trainingGroupsId === _ctx.TRAINING_GROUPS_OPTIONS.COMPETITOR.KEY)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 2,
                      multiple: "",
                      disabled: _ctx.isLoading || _ctx.competitorOptions.length < 1,
                      modelValue: _ctx.formModel.id_competitor,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formModel.id_competitor) = $event)),
                      type: "text",
                      placeholder: "Selecione um ou mais vendedores",
                      name: "form-training-put-groups-2",
                      id: "form-training-put-groups-2",
                      class: "w-100"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competitorOptions, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.key,
                            value: option.key,
                            label: option.label
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["disabled", "modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_CampTable, { class: "mb-0 mt-0" }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createVNode(_component_CampTableTh, { class: "py-4" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Questionário")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, {
                    class: "py-4",
                    style: {"width":"12rem"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Opções")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, {
                    class: "py-4",
                    style: {"width":"18rem"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ações")
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.questionList.length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionList, (question, id) => {
                      return (_openBlock(), _createElementBlock("tr", { key: id }, [
                        _createVNode(_component_CampTableTd, { class: "py-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(question.title), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_CampTableTd, { class: "py-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(question.alternatives.filter(el => !el.del).length), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_CampTableTd, { class: "py-2 d-flex gap-4" }, {
                          default: _withCtx(() => [
                            (question.del)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.handleUndoRemoveQuestion(id)),
                                  type: "button",
                                  class: "btn btn-sm background_btn_1_opct w-100 d-flex justify-content-center align-items-center"
                                }, [
                                  _hoisted_35,
                                  _createTextVNode(" Desfazer ")
                                ], 8, _hoisted_34))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.handleRemoveQuestion(id)),
                                    type: "button",
                                    class: "btn btn-sm background_btn_1_opct w-100 d-flex justify-content-between align-items-center"
                                  }, [
                                    _hoisted_37,
                                    _createTextVNode(" Excluir ")
                                  ], 8, _hoisted_36),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.handleEditQuestion(question, id)),
                                    type: "button",
                                    class: "btn btn-sm background_btn_1_opct w-100 d-flex justify-content-between align-items-center"
                                  }, [
                                    _hoisted_39,
                                    _createTextVNode(" Editar ")
                                  ], 8, _hoisted_38)
                                ], 64))
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "col-12 p-4 d-flex justify-content-center",
            style: _normalizeStyle(`background-color: ${_ctx.questionList.length % 2 == 0 ? 'var(--cor_background_3)': 'var(--cor_background_1)'}`)
          }, [
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = () => (_ctx.handleQuizModalToggle(), _ctx.resetQuizModal())),
              type: "button",
              class: "btn background_btn_1_opct"
            }, [
              _hoisted_40,
              _createTextVNode(" Adicionar perguntas ")
            ])
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_CampTable, { class: "mb-0 mt-0" }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createVNode(_component_CampTableTh, { class: "py-4" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Certificado")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("fieldset", {
            class: "certificate_card",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.resetWarning && _ctx.resetWarning(...args)))
          }, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createVNode(_component_el_switch, {
                  id: "form-training-put-certificate-issue",
                  modelValue: _ctx.certificateIssueStatus,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.certificateIssueStatus) = $event)),
                  style: {"--el-switch-on-color":"var(--el-color-primary)"}
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_ctx.certificateIssueStatus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode(_component_el_input, {
                        placeholder: "Nome do responsável pelo certificado",
                        modelValue: _ctx.formModel.certificate_responsible_name,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formModel.certificate_responsible_name) = $event)),
                        clearable: "",
                        type: "text",
                        name: "form-training-put-certificate-responsible",
                        id: "form-training-put-certificate-responsible"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createVNode(_component_el_input, {
                        placeholder: "Ex: 8",
                        modelValue: _ctx.formModel.certificate_workload,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formModel.certificate_workload) = $event)),
                        clearable: "",
                        type: "number",
                        name: "form-training-put-certificate-workload",
                        id: "form-training-put-certificate-workload"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      (!_ctx.certificateLogoPreview)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_54, [
                            _createElementVNode("input", {
                              type: "file",
                              accept: "image/png,image/jpeg",
                              onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleCertificateLogoChange && _ctx.handleCertificateLogoChange(...args))),
                              class: "logo-upload-input"
                            }, null, 32),
                            _hoisted_55
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.certificateLogoPreview || _ctx.formModel.certificate_logo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createElementVNode("img", {
                              src: _ctx.certificateLogoPreview || _ctx.formModel.certificate_logo,
                              alt: "Preview logo"
                            }, null, 8, _hoisted_57),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-secondary ms-2",
                              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.removeCertificateLogoFile && _ctx.removeCertificateLogoFile(...args)))
                            }, "Remover")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createVNode(_component_el_input, {
                        placeholder: "Cargo do responsável",
                        modelValue: _ctx.formModel.certificate_responsible_position,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formModel.certificate_responsible_position) = $event)),
                        clearable: "",
                        type: "text",
                        name: "form-training-put-certificate-position",
                        id: "form-training-put-certificate-position"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      (_ctx.savedSignatureData)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _hoisted_62,
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("img", {
                                src: _ctx.savedSignatureData.signature,
                                alt: "Assinatura",
                                class: "preview-img"
                              }, null, 8, _hoisted_64),
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.savedSignatureData.name), 1),
                                _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.savedSignatureData.role), 1),
                                _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.savedSignatureData.company), 1)
                              ])
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn-signature",
                              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleSignatureModalToggle && _ctx.handleSignatureModalToggle(...args)))
                            }, " Editar assinatura ")
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _hoisted_70,
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn-signature",
                              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleSignatureModalToggle && _ctx.handleSignatureModalToggle(...args)))
                            }, " Cadastrar assinatura ")
                          ])),
                      _createVNode(_component_SignatureModal, {
                        toggle: _ctx.signatureModalToggle,
                        "initial-data": _ctx.savedSignatureData,
                        onClose: _ctx.handleSignatureModalToggle,
                        onSave: _ctx.handleSaveSignature
                      }, null, 8, ["toggle", "initial-data", "onClose", "onSave"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_CampFormRackSubmitBtn, { class: "pe-2" }, {
          default: _withCtx(() => [
            _hoisted_71
          ]),
          _: 1
        })
      ], 32)
    ]),
    _createVNode(_component_ModalQuiz, {
      toggle: _ctx.quizModalToggle,
      question: _ctx.question,
      editQuestionId: _ctx.editQuestionId,
      "onGet:Question": _ctx.handleQuestion
    }, null, 8, ["toggle", "question", "editQuestionId", "onGet:Question"])
  ]))
}